import { maybeReportAppInstall } from '../report-app-install';
import type { AppsflyerUidPayload } from '../types';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';

export function handleAppsflyerUid(payload: AppsflyerUidPayload): void {
  if (!payload.uid) {
    return;
  }

  useUserJourneyStore().setAppsflyer({
    id: payload.uid,
    platform: payload.platform,
    advertising_id: payload.advertising_id,
    idfv: payload.idfv,
    os_version: payload.os_version,
  });

  // UID acabou de chegar: se a conversion data (is_first_launch) ja estava
  // no store, fecha a condicao e dispara o app_install agora.
  maybeReportAppInstall().catch(() => {
    // silencioso — nao bloqueia o fluxo de boot do app
  });
}
